module.exports = __webpack_public_path__ + "media/images/logo-s-8abe62b9a2d0c49c8253d728b35bd945.png";